import request from 'umi-request';
import { environment } from './../../environment/environment';
import type { ApiResponse } from '../model/apiResponse';
import type { CreateUpdateVehicleDto } from '../model/vehicle';

//List products
export async function GetVehicleList(token: string): Promise<ApiResponse> {
  return await request('/vehicle/currentUser', {
    method: 'GET',
    prefix: environment.baseUrl,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

export async function GetVehicle(token: string, id: string): Promise<ApiResponse> {
  return await request('/vehicle/withDocs/', {
    method: 'GET',
    prefix: environment.baseUrl,
    suffix: id,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

export async function CreateVehicle(vehicle: CreateUpdateVehicleDto, token: string): Promise<ApiResponse> {
  return request('/vehicle', {
    method: 'POST',
    prefix: environment.baseUrl,
    body: JSON.stringify(vehicle),
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (reponse: ApiResponse) {
      return reponse
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

export async function EditVehicle(vehicleRequest: CreateUpdateVehicleDto, token: string): Promise<ApiResponse> {
  return request(`/vehicle/${vehicleRequest.id}`, {
    method: 'PUT',
    prefix: environment.baseUrl,
    body: JSON.stringify(vehicleRequest),
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (reponse: ApiResponse) {
      return reponse
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

export async function DeleteVehicle(token: string, id: string): Promise<ApiResponse> {
  return await request('/vehicle/', {
    method: 'DELETE',
    prefix: environment.baseUrl,
    suffix: id,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}